import { undent } from '@bymason/utils';
import { CmsProductDetailsWidget } from './types';

export default [
  {
    productId: 'A4100',
    heading: 'A4100',
    subheading: '2-inch Smartwatch',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/a4100/A4100_larger_wp.png',
    description: undent`Our customizable smartwatch has been purpose-built for the enterprise use case. Your 
      blank slate to leverage built-in features like GPS, biometric sensors, front-facing camera, and more to 
      build your smart product line as envisioned.`,
    specs: [
      { label: 'Size', value: '49.64*40.91*15.96mm' },
      { label: 'Weight', value: '100g' },
      { label: 'Color', value: 'Black' },
      { label: 'Chipset', value: 'Qualcomm Snapdragon Wear 4100' },
      { label: 'Processor', value: 'Quad-core Qualcomm SDM429W 2.0GHz' },
      { label: 'GPU', value: 'Adreno 504 320MHz' },
      { label: 'OS', value: 'Android 8' },
      { label: 'RAM', value: '1GB' },
      { label: 'Storage', value: '8GB' },
      { label: 'Battery Capacity', value: '650mAh' },
      { label: 'Camera Pixels', value: 'Front: 5MP FF Rear: None' },
    ],
    productDetailsCta: {
      caption: 'Buy Smartwatch',
      subcaption: 'Coming soon!',
    },
    specImageUrls: [
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/a4100/a4100-profile.png',
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/a4100/a4100-schematic.png',
    ],
  },
  {
    productId: 'D215',
    heading: 'D215',
    subheading: '6-inch Handheld',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d215/D215_wp.png',
    description: undent`Ruggedized and built for extreme conditions, our low-cost D215 Handheld is available 
      out-of-the-box customized to 8 and 10-inch displays, delivered to market in under six months. A removable 
      battery allows for easy battery swap out for continuous use and increases the device lifecycle. Mount it 
      via magnet for travel logging, RPM in hospital or at home, industrial settings, and more.`,
    specs: [
      { label: 'Size', value: '163*79.1*11.5mm' },
      { label: 'Weight', value: '215g' },
      { label: 'Color', value: 'Black' },
      { label: 'Chipset', value: 'Qualcomm Snapdragon 215' },
      { label: 'Processor', value: 'Qual-core Arm cortex-53 1.3GHz' },
      {
        label: 'GPU',
        value: 'Andreno 308 with 64 bit processing 465 MHz',
      },
      {
        label: 'OS',
        value: 'Mason OS 6.x (customizable Android 11 operating system)',
      },
      { label: 'RAM', value: '2 GB' },
      { label: 'Storage', value: '16 GB' },
      { label: 'Battery Capacity', value: '3000 mAh' },
      {
        label: 'Camera Pixels',
        value: 'Front: 5MP ( only in advanced version) Rear: 8MP',
      },
    ],
    productDetailsCta: {
      caption: 'Buy Handheld',
      subcaption: '',
    },
    specImageUrls: [
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d215/d215-profile.png',
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d215/d215-schematic.png',
    ],
  },
  {
    productId: 'D450',
    heading: 'D450',
    subheading: '6-inch Handheld',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d450/D450_wp.png',
    description: undent`Versatile, long-lasting, and globally certified, the D450 handheld is our most popular 
      device. Global connectivity and a powerful chipset deliver your smart solution to end users easily and 
      efficiently. Turn-key and ready to go right out of the box, this device is often paired with accessories 
      across industries to deliver modular products.`,
    specs: [
      { label: 'Size', value: '160*76*8.95mm' },
      { label: 'Weight', value: '178g' },
      { label: 'Color', value: 'Black' },
      { label: 'Chipset', value: 'Qualcomm Snapdragon 450' },
      { label: 'Processor', value: 'Octa Core Qualcomm SDM450 1.8GHz' },
      { label: 'GPU', value: 'Adreno 506 475MHz' },
      { label: 'OS', value: 'Android 7.1.2' },
      { label: 'RAM', value: '2GB' },
      { label: 'Storage', value: '16GB' },
      { label: 'Battery Capacity', value: '4000mAh' },
      {
        label: 'Camera Pixels',
        value: 'Front: 8MP Rear: 16.0MP AF+2M FF Dual Camera',
      },
    ],
    productDetailsCta: {
      caption: 'Buy Handheld',
      subcaption: '',
    },
    specImageUrls: [
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d450/d450-profile.png',
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d450/d450-schematic.png',
    ],
  },
  {
    productId: 'G450',
    heading: 'G450',
    subheading: '10-inch Tablet',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/g450/G450_wp.png',
    description: undent`Your go-to solution for larger-screen use cases, this tablet offers enhanced accessibility 
      and font readability. Certified in over 50 countries. Global connectivity, a powerful chipset, and versatile 
      charging and data transfer options via pogo pins make this tablet’s capabilities as big as your ideas.`,
    specs: [
      { label: 'Size', value: '626*153.2*9.2mm' },
      { label: 'Weight', value: '573g' },
      { label: 'Color', value: 'Black' },
      { label: 'Chipset', value: 'Qualcomm Snapdragon 450' },
      { label: 'Processor', value: 'Octa Core Qualcomm SDM450 1.8GHz' },
      { label: 'GPU', value: 'Adreno 506 475MHz' },
      { label: 'OS', value: '7.1.2' },
      { label: 'RAM', value: '2GB' },
      { label: 'Storage', value: '32GB' },
      { label: 'Battery Capacity', value: '8500 mAh' },
      { label: 'Camera Pixels', value: 'Front: 8MP Rear: 16MP AF' },
    ],
    productDetailsCta: {
      caption: 'Buy Tablet',
      subcaption: '',
    },
    specImageUrls: [
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/g450/g450-profile.png',
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/g450/g450-schematic.png',
    ],
  },
] as CmsProductDetailsWidget[];
